import React, { useEffect, useContext, useState } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./EditCompetencyForm.css";

function EditCompetencyForm() {
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [name_english, setNameEnglish] = useState("");
  const [description_english, setDescriptionEnglish] = useState("");
  const [english, setEnglish] = useState(false);

  const { state } = useContext(AuthContext);

  const navigate = useNavigate();

  let { cid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/competencies/${cid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.competency.name);
      setNameEnglish(response.data.competency.name_english);
      setDescription(response.data.competency.description);
      setDescriptionEnglish(response.data.competency.description_english);

      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }

      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleNameEnglishChange = (e) => {
    setNameEnglish(e.target.value);
  };

  const handleDescriptionEnglishChange = (e) => {
    setDescriptionEnglish(e.target.value);
  };

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/competencies/${cid}`,
        data: {
          name: name,
          description: description,
          name_english: name_english,
          description_english: description_english,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/behaviors/competencies");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Competencias" : "Competencies",
      path: "/behaviors/competencies",
    },
  ];

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row>
          <Col lg={11} className="edit-competency-header">
            <h2>{t("Competencias.Competencia.EditForm.EditarCompetencia")}</h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col className="edit-competency-form">
            <Form>
              <FloatingLabel
                controlId="floatingInput"
                label="Nombre de la competencia"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="nombre de la competencia"
                  onChange={handleNameChange}
                  value={name}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel label="Competency name" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Competency name"
                    onChange={handleNameEnglishChange}
                    value={name_english}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <FloatingLabel
                controlId="floatingInput"
                label="Descripción de la competencia"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="descripción de la competencia"
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </FloatingLabel>
              {english ? (
                <FloatingLabel label="Competency description">
                  <Form.Control
                    type="text"
                    placeholder="Competency description"
                    onChange={handleDescriptionEnglishChange}
                    value={description_english}
                  />
                </FloatingLabel>
              ) : (
                <></>
              )}
              <Button className="primary" onClick={handleSubmit}>
                {t("Competencias.Competencia.EditForm.Guardar")}
              </Button>
              <Link to="/behaviors/competencies">
                <Button className="danger">
                  {t("Competencias.Competencia.EditForm.Cancelar")}
                </Button>
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EditCompetencyForm;
